import { RunStateTransition } from "types/generated";
import UnfinishedRunActions from "components/Run/elements/UnfinishedRunActions";

import FailedEntry from "../entries/FailedEntry";
import { getRunStateTransitionId } from "./getRunStateTransitionId";
import { RunEntryContext } from "../types";

export const createFailedEntry = (
  { timestamp, note, stateVersion }: RunStateTransition,
  {
    canPerformAgain,
    stackId,
    runTaskCommand,
    runId,
    canRetry,
    runRetryBlocker,
    isTaskRun,
    isModuleRun,
  }: RunEntryContext
) => (
  <FailedEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    note={note}
  >
    <UnfinishedRunActions
      stackId={stackId}
      runId={runId}
      canRetry={canRetry}
      runRetryBlocker={runRetryBlocker}
      isTaskRun={isTaskRun}
      isModuleRun={isModuleRun}
      canPerformAgain={canPerformAgain}
      runTaskCommand={runTaskCommand}
    />
  </FailedEntry>
);
